#import "../fragments/task-sync.graphql"

query GetTaskSync {
    loggedInUser {
        id
        taskSync {
            ...TaskSync
        }
        calendarSync {
            isEnabled
            externalService
        }
    }
}
